import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import MenuBar from "./components/MenuBar";
import HeroSection from "./components/HeroSection";
import ServicesPills from "./components/ServicesPills";
import ServicesDetailSection from "./components/ServicesDetailSection";
import ActionSection from "./components/ActionSection";
import ValuePropsSection from "./components/ValuePropsSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import PageSEO from "./components/PageSEO";
import SeoServicePage from "./pages/SeoServicePage";
import ContactUsPage from "./pages/ContactUsPage";
import PaidSearchPage from "./pages/PaidSearchPage";
import PaidSocialPage from "./pages/PaidSocialPage";
import CROPage from "./pages/CROPage";
import LifecycleMarketingPage from "./pages/LifecycleMarketingPage";

function HomePage() {
  return (
    <div className="app-shell" id="top">
      <PageSEO
        title="Sparkdenz | Lead Generation, SEO & Paid Media Agency"
        description="Sparkdenz helps brands scale with lead generation, SEO, paid search, paid social, CRO, and lifecycle marketing services focused on measurable growth."
        canonicalPath="/"
      />
      <MenuBar />
      <main>
        <HeroSection />
        <ServicesPills />
        <ServicesDetailSection />
        <ActionSection />
        <ValuePropsSection />
        <AboutSection />
        <ContactSection />
      </main>
      <FooterSection />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/seo-service" element={<SeoServicePage />} />
        <Route path="/paid-search" element={<PaidSearchPage />} />
        <Route path="/paid-social" element={<PaidSocialPage />} />
        <Route path="/cro" element={<CROPage />} />
        <Route path="/lifecycle-marketing" element={<LifecycleMarketingPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
      </Routes>
    </Router>
  );
}
